import { render, staticRenderFns } from "./BoCustomerAlert.vue?vue&type=template&id=51cf21a0"
import script from "./BoCustomerAlert.vue?vue&type=script&lang=js"
export * from "./BoCustomerAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports